import React from 'react';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';

const useApproveOwnershipConfirmation = (
  isLoading,
  hasBIN,
  isStartAssessment,
  transactionStatus,
  taxpayerID,
  onYesCallBack,
  onNoCallback = () => {}
) => {
  const isAllowed = true;

  const isStatusAllowed = ['FOR CHECKING'].indexOf(transactionStatus) > -1;

  const showComponent =
    isAllowed && isStartAssessment && hasBIN && isStatusAllowed && !taxpayerID;

  const onHandleClick = e => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure, do you want Approve Ownership for this application?`,
      onYesCallBack,
      onNoCallback,
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const component = showComponent ? (
    <div className="mx-2">
      <button
        disabled={isLoading}
        onClick={onHandleClick}
        type="button"
        className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold   "
      >
        {isLoading && (
          <>
            <i className="fas fa-spinner fa-spin" />
            &nbsp;
          </>
        )}
        Approve Ownership
      </button>
    </div>
  ) : null;

  return {
    isAllowed,
    onHandleClick,
    component,
  };
};

export default useApproveOwnershipConfirmation;
